import { render, staticRenderFns } from "./FormFieldsets.vue?vue&type=template&id=a32b2a82"
import script from "./FormFieldsets.vue?vue&type=script&setup=true&lang=js"
export * from "./FormFieldsets.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports